import './checkout_payments.css';
import { Elements, PaymentElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { CreditCardIcon } from "../../assets/icons/CreditCardIcon";
import { useCheckout } from "../../context/CheckoutContext";
import { CheckoutFormStep } from "../CheckoutFormStep/CheckoutFormStep";
import { PaymentMethod } from '../../Enum/PaymentMethod';
import { useState } from 'react';
import { useBus, useListener } from 'react-bus';
import { serverEnv } from '../../env';

var price = 0;
var tax = 8.875;
var total = price * (tax / 100);

export const CheckoutPaymentsWrapper = () => {
    //HOOKS
    const {
        stripeSettings,
        stripeClientSecret,
        stripePromise,
        stripeOptions,
    } = useCheckout();

    return (
        <CheckoutFormStep
            step={2}
            title={'Payment'}
            icon={<CreditCardIcon />}
            id={"checkout_payment"}
        >
            {
                stripeSettings && stripeSettings.enable && stripePromise.current != null && stripeClientSecret !== "" && stripeOptions.current != null && (
                    <Elements stripe={stripePromise.current} options={stripeOptions.current}>
                        <CheckoutPayments />
                    </Elements>
                )
            }

            {
                stripeSettings && !stripeSettings.enable && (
                    <CheckoutPayments />
                )
            }
        </CheckoutFormStep>
    );
}

const CheckoutPayments = () => {
    //HOOKS
    const {
        stripeSettings,
        paymentMethod,
        setPaymentMethod,
        cashSettings,
        tip,
        setTip,
        setCheckoutStep,
    } = useCheckout();
    const bus = useBus();

    //STATES
    const [stripeError, setStripeError] = useState("");
    const [order, setOrder] = useState(null);

    const stripe = useStripe();
    const elements = useElements();

    //LISTENERS
    useListener('submit_stripe_payment', async (order) => {
        setOrder(order);
        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                return_url: serverEnv.backend + "/api/public/v1/stripe/payment/order/" + order.id + "/order_online/" + document.settings.id + "/confirm",
            }
        });

        if (error)
        {
            setCheckoutStep(2);
            setStripeError(error.message);
        }
    });

    return (
        <>
             <div className='checkout_payment_method_selector'>
                {stripeSettings && stripeSettings.enable &&
                    (
                        <button className={(paymentMethod === PaymentMethod.STRIPE) ? 'active' : ''} onClick={() => setPaymentMethod(PaymentMethod.STRIPE)}>
                            Credit Card
                        </button>
                    )
                }
                
                {/*paypalSetttings && paypalSetttings.enable === 1 &&
                    (
                        <button className={(selectedPaymentMethod === 3) ? 'active' : ''} onClick={() => setSelectedPaymentMethod(3)}>
                            PayPal
                        </button>
                    )
                */}

                {cashSettings && cashSettings.enable &&
                    (
                        <button className={(paymentMethod === PaymentMethod.CASH) ? 'active' : ''} onClick={() => setPaymentMethod(PaymentMethod.CASH)}>
                            Cash
                        </button>
                    )
                }
            </div>

           {stripeSettings && stripeSettings.enable && paymentMethod === PaymentMethod.STRIPE &&
                (
                    <div className='checkout_payment_container stripe'>
                        <PaymentElement />
                    </div>
                )
            } 

            <div className='checkout_input_container'>
                <span>{stripeError}</span>
            </div>

            {paymentMethod === PaymentMethod.CASH && (
                    <div className='checkout_payment_container'>
                        <h2 className='paypal_method_message'>
                            Cash
                        </h2>
                        
                    </div>
                )
            }

            <div className='checkout_input_container'>
                <label>
                    Leave Tip
                </label>
                <input type='number' value={tip} onChange={(e) => setTip(parseFloat(e.target.value))} disabled={order !== null} />
            </div>

            <div className='checkout_delivery_continue_container'>
                {
                    order && paymentMethod === PaymentMethod.STRIPE && (
                        <button onClick={() => {bus.emit('submit_stripe_payment', order)}}>
                            Pay now
                        </button>
                    )
                }
                {
                    !(order && paymentMethod === PaymentMethod.STRIPE) && (
                        <button onClick={() => setCheckoutStep(3)}>
                            Continue
                        </button>
                    )
                }
            </div>
        </>
    );
}